// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Dui-F","modalTitle":"styles_modalTitle__wHEKE"};